import React, { useState } from 'react';
import { Helmet } from 'react-helmet';

const DocsPage = () => {
  const [selectedSection, setSelectedSection] = useState('sms-textr-doc'); // Default section
  const [showLanguages, setShowLanguages] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null); // State to track hovered item

  // Function to render the content based on the selected section
  const renderContent = () => {
    switch (selectedSection) {
      case 'sms-textr-doc':
        return <Doc />;
      case 'send-sms':
        return <SendSms />;
      case 'response':
        return <ResponseReceived />;
      case 'testing-api':
        return <TestingAPI />;
      case 'ReceivingSMSReplies':
          return <ReceivingSMSReplies />;
      case 'supported-regions':
          return <SupportedRegions />;
      case 'send-sms-curl':
        return <CurlExample />;
      case 'send-sms-python':
        return <PythonExample />;
      case 'send-sms-php':
        return <PHPExample />;
      case 'send-sms-ruby':
        return <RubyExample />;
      case 'send-sms-nodejs':
        return <NodeExample />;
      case 'send-sms-javascript':
        return <JSExample />;
      case 'send-sms-csharp':
        return <CSharpExample />;
      case 'send-sms-java':
        return <JavaExample />;
        //return <LanguageExample language={selectedSection.split('-')[2]} />;
      default:
        return <Doc />;
    }
  };

   // Function to generate the page title based on the selected section
   const getPageTitle = () => {
    switch (selectedSection) {
      case 'sms-textr-doc':
        return 'SMS Textr Documentation';
      case 'send-sms':
        return 'Send SMS using HTTP POST | SMS Textr';
      case 'response':
        return 'Response Received | SMS Textr';
      case 'testing-api':
        return 'Testing API | SMS Textr';
       case 'ReceivingReplies':
          return 'Receiving SMS | SMS Textr';
      case 'supported-regions':
        return 'Supported Regions | SMS Textr';
      case 'send-sms-curl':
        return 'Send SMS with Curl | SMS Textr';
      case 'send-sms-python':
        return 'Send SMS with Python | SMS Textr';
      case 'send-sms-php':
        return 'Send SMS with PHP | SMS Textr';
      case 'send-sms-ruby':
        return 'Send SMS with Ruby | SMS Textr';
      case 'send-sms-nodejs':
        return 'Send SMS with Node.js | SMS Textr';
      case 'send-sms-javascript':
        return 'Send SMS with JavaScript | SMS Textr';
      case 'send-sms-csharp':
        return 'Send SMS with C# | SMS Textr';
      case 'send-sms-java':
        return 'Send SMS with Java | SMS Textr';
      default:
        return 'SMS Textr Documentation';
    }
  };

  return (
    <div style={{ display: 'flex' }}>
      {/* Helmet for setting the document head */}
      <Helmet>
        <title>{getPageTitle()}</title>
        <meta name="description" content="Explore the SMS Textr documentation for sending SMS programmatically." />
        <meta name="keywords" content="SMS API documentation, SMS Textr API, API guide, SMS integration, SMS API for developers, API reference, SMS API tutorial, SMS messaging API, developer documentation, send SMS programmatically" />
        <meta name="author" content="SMS Textr Team" />
      </Helmet>
      {/* Sidebar */}
      <div style={sidebarStyle}>
        <button 
          style={{ color: 'green', fontSize: '1.5em', background: 'none', border: 'none', cursor: 'pointer' }} 
          onClick={() => setSelectedSection('sms-textr-doc')}
        >
          SMS Textr Documentation
        </button>
        
        <div style={{ marginBottom: '20px' }}></div>
        
        <ul style={listStyle}>
          <li 
            onMouseEnter={() => setHoveredItem('send-sms')} 
            onMouseLeave={() => setHoveredItem(null)} 
            onClick={() => setSelectedSection('send-sms')} 
            style={{ 
              ...listItemStyle, 
              color: hoveredItem === 'send-sms' ? 'green' : 'black' // Change text color based on hover
            }}
          >
            Send an SMS using HTTP POST
          </li>
          <li 
            onMouseEnter={() => setHoveredItem('languages')} 
            onMouseLeave={() => setHoveredItem(null)} 
            style={{ 
              ...listItemStyle, 
              color: hoveredItem === 'languages' ? 'green' : 'black' // Change text color based on hover
            }} 
            onClick={() => setShowLanguages(!showLanguages)} // Toggle visibility of languages
          >
            Send an SMS {showLanguages ? '(-)' : '(+)'}
            <ul style={{ display: showLanguages ? 'block' : 'none' }}>
              {/* Language items updated to prevent collapsing */}
              <li 
                onMouseEnter={() => setHoveredItem('send-sms-curl')} 
                onMouseLeave={() => setHoveredItem(null)} 
                onClick={(e) => { e.stopPropagation(); setSelectedSection('send-sms-curl'); }} // Prevent collapse
                style={{ 
                  ...listItemStyle, 
                  color: hoveredItem === 'send-sms-curl' ? 'green' : 'black' // Change text color based on hover
                }}
              >
                Curl
              </li>
              <li 
                onMouseEnter={() => setHoveredItem('send-sms-python')} 
                onMouseLeave={() => setHoveredItem(null)} 
                onClick={(e) => { e.stopPropagation(); setSelectedSection('send-sms-python'); }} // Prevent collapse
                style={{ 
                  ...listItemStyle, 
                  color: hoveredItem === 'send-sms-python' ? 'green' : 'black' // Change text color based on hover
                }}
              >
                Python
              </li>
              <li 
                onMouseEnter={() => setHoveredItem('send-sms-php')} 
                onMouseLeave={() => setHoveredItem(null)} 
                onClick={(e) => { e.stopPropagation(); setSelectedSection('send-sms-php'); }} // Prevent collapse
                style={{ 
                  ...listItemStyle, 
                  color: hoveredItem === 'send-sms-php' ? 'green' : 'black' // Change text color based on hover
                }}
              >
                PHP
              </li>
              <li 
                onMouseEnter={() => setHoveredItem('send-sms-ruby')} 
                onMouseLeave={() => setHoveredItem(null)} 
                onClick={(e) => { e.stopPropagation(); setSelectedSection('send-sms-ruby'); }} // Prevent collapse
                style={{ 
                  ...listItemStyle, 
                  color: hoveredItem === 'send-sms-ruby' ? 'green' : 'black' // Change text color based on hover
                }}
              >
                Ruby
              </li>
              <li 
                onMouseEnter={() => setHoveredItem('send-sms-nodejs')} 
                onMouseLeave={() => setHoveredItem(null)} 
                onClick={(e) => { e.stopPropagation(); setSelectedSection('send-sms-nodejs'); }} // Prevent collapse
                style={{ 
                  ...listItemStyle, 
                  color: hoveredItem === 'send-sms-nodejs' ? 'green' : 'black' // Change text color based on hover
                }}
              >
                NodeJs
              </li>
              <li 
                onMouseEnter={() => setHoveredItem('send-sms-javascript')} 
                onMouseLeave={() => setHoveredItem(null)} 
                onClick={(e) => { e.stopPropagation(); setSelectedSection('send-sms-javascript'); }} // Prevent collapse
                style={{ 
                  ...listItemStyle, 
                  color: hoveredItem === 'send-sms-javascript' ? 'green' : 'black' // Change text color based on hover
                }}
              >
                Javascript
              </li>
              <li 
                onMouseEnter={() => setHoveredItem('send-sms-csharp')} 
                onMouseLeave={() => setHoveredItem(null)} 
                onClick={(e) => { e.stopPropagation(); setSelectedSection('send-sms-csharp'); }} // Prevent collapse
                style={{ 
                  ...listItemStyle, 
                  color: hoveredItem === 'send-sms-csharp' ? 'green' : 'black' // Change text color based on hover
                }}
              >
                C#
              </li>
              <li 
                onMouseEnter={() => setHoveredItem('send-sms-java')} 
                onMouseLeave={() => setHoveredItem(null)} 
                onClick={(e) => { e.stopPropagation(); setSelectedSection('send-sms-java'); }} // Prevent collapse
                style={{ 
                  ...listItemStyle, 
                  color: hoveredItem === 'send-sms-java' ? 'green' : 'black' // Change text color based on hover
                }}
              >
                Java
              </li>
            </ul>
          </li>
          <li 
            onMouseEnter={() => setHoveredItem('response')} 
            onMouseLeave={() => setHoveredItem(null)} 
            onClick={() => setSelectedSection('response')} 
            style={{ 
              ...listItemStyle, 
              color: hoveredItem === 'response' ? 'green' : 'black' // Change text color based on hover
            }}
          >
            Response Received
          </li>
          <li 
            onMouseEnter={() => setHoveredItem('testing-api')} 
            onMouseLeave={() => setHoveredItem(null)} 
            onClick={() => setSelectedSection('testing-api')} 
            style={{ 
              ...listItemStyle, 
              color: hoveredItem === 'testing-api' ? 'green' : 'black' // Change text color based on hover
            }}
          >
            Testing the API
          </li>
          <li 
            onMouseEnter={() => setHoveredItem('ReceivingSMSReplies')} 
            onMouseLeave={() => setHoveredItem(null)} 
            onClick={() => setSelectedSection('ReceivingSMSReplies')} 
            style={{ 
              ...listItemStyle, 
              color: hoveredItem === 'ReceivingSMSReplies' ? 'green' : 'black' // Change text color based on hover
            }}
          >
            Receving SMS Replies
          </li>
          <li 
            onMouseEnter={() => setHoveredItem('supported-regions')} 
            onMouseLeave={() => setHoveredItem(null)} 
            onClick={() => setSelectedSection('supported-regions')} 
            style={{ 
              ...listItemStyle, 
              color: hoveredItem === 'supported-regions' ? 'green' : 'black' // Change text color based on hover
            }}
          >
            Supported Regions
          </li>
        </ul>
      </div>

      {/* Content Area */}
      <div style={contentStyle}>
        {renderContent()}
      </div>
    </div>
  );
};

// Sidebar styling
const sidebarStyle = {
  width: '250px', // Fixed width for sidebar
  maxWidth: '250px', // Ensure it doesn't expand
  minWidth: '250px', // Ensure it doesn't shrink
  padding: '20px',
  backgroundColor: '#f4f4f4',
  borderRight: '1px solid #ddd',
  overflow: 'hidden', // Prevent overflow
};

// List styling for the sidebar
const listStyle = {
  listStyleType: 'none',
  paddingLeft: '0',
  margin: '0', // Added to remove default margin
};

const listItemHoverStyle = {
  color: 'green', // Change text color to green on hover
};

const listItemStyle = {
  padding: '7px 0', // Added padding for spacing
  cursor: 'pointer', // Change cursor to pointer for better UX
  transition: 'color 0.3s', // Smooth transition for text color on hover
};

// Content area styling
const contentStyle = {
  padding: '20px',
  flexGrow: 1,
};

// Components for different sections
const Doc = () => (
  <div style={{ 
    background: 'linear-gradient(135deg, #f9f9f9, #eaeaea)', // Gradient background for depth
    borderRadius: '8px', // Rounded corners
    padding: '20px', // Padding for spacing
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)', // Enhanced shadow for depth
    marginBottom: '20px', // Space below the component
    transition: 'transform 0.3s, box-shadow 0.3s', // Smooth transition for hover effect
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.transform = 'scale(1.02)'; // Slightly scale up on hover
    e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.2)'; // Deeper shadow on hover
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.transform = 'scale(1)'; // Reset scale on leave
    e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)'; // Reset shadow on leave
  }}
  >
    <h2 style={{ 
      marginBottom: '10px', 
      color: '#333', 
      fontFamily: 'Arial, sans-serif', // Modern font
      fontSize: '1.8em', // Larger font size for the heading
    }}>
      SMS Textr
    </h2>
    <p style={{ 
      lineHeight: '1.6', 
      color: '#555', 
      fontFamily: 'Arial, sans-serif', // Consistent font
      fontSize: '1em', // Standard font size for the paragraph
    }}>
      SMS Textr is an SMS API designed for developers who need a straightforward solution
      to send and receive SMS. The platform simplifies SMS sending with a pay-as-you-go model, 
      eliminating the need for complex account setups or recurring billing. Users also have access
      to a secure login dashboard where they can view SMS credits purchased and used, 
      track sent messages, and monitor billing history.
    </p>
    <br /><br /><br />
    <p style={{ 
      lineHeight: '1.6', 
      color: '#555', 
      fontFamily: 'Arial, sans-serif', // Consistent font
      fontSize: '1em', // Standard font size for the paragraph
    }}>
      SMS Textr now supports sending SMS messages to multiple countries, including the USA, Canada, UK, Thailand, Portugal, India, Germany, Spain, Poland, Italy, and Australia. Our service remains reliable, cost-effective, and tailored to meet your global communication needs, with plans to expand to even more regions in the future.
    </p>
  </div>
);

const SendSms = () => (
  <div style={{ 
    background: 'linear-gradient(135deg, #f9f9f9, #eaeaea)', // Gradient background for depth
    borderRadius: '8px', // Rounded corners
    padding: '20px', // Padding for spacing
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)', // Enhanced shadow for depth
    marginBottom: '20px', // Space below the component
    transition: 'transform 0.3s, box-shadow 0.3s', // Smooth transition for hover effect
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.transform = 'scale(1.02)'; // Slightly scale up on hover
    e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.2)'; // Deeper shadow on hover
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.transform = 'scale(1)'; // Reset scale on leave
    e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)'; // Reset shadow on leave
  }}
  >
    <h2 style={{ marginBottom: '10px', color: '#333' }}>Send an SMS using HTTP POST</h2>
    <pre style={{ background: '#f0f0f0', padding: '10px', borderRadius: '5px', whiteSpace: 'pre-wrap' }}>
      <code>
        The <span style={{ color: 'green' }}>https://smstextr.web.app/api/sendsms</span> endpoint accepts a POST request with the following parameters:<br /><br />
        
        - <strong><b>To:</b></strong>       The recipient’s phone number. Currently supporting on USA and Canada phone numbers.<br />
        - <strong><b>Message:</b></strong>  The content of the SMS message to be sent.<br />
        - <strong><b>Apikey:</b></strong>   Your unique API key for authentication and billing.<br /><br />

        Instead of installing a special SMS Textr library, just send a POST request using your preferred method and we'll handle the rest.
      </code>
    </pre>
  </div>
);

const PythonExample = () => {
  const codeSnippet = `        import requests

        url = "https://smstextr.web.app/api/sendsms"
        payload = { "to": "+1 123-456-7890", 
                    "message": "Hello from SMS Textr API!",
                    "apikey": "Your_API_Key" }

        response = requests.post(url, json=payload)
        print(response.json())`;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(codeSnippet).then(() => {
      alert('Code copied to clipboard!'); // Optional: Notify the user
    });
  };

  return (
    <div style={{ 
      background: 'linear-gradient(135deg, #f9f9f9, #eaeaea)', // Gradient background for depth
      borderRadius: '8px', // Rounded corners
      padding: '20px', // Padding for spacing
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)', // Enhanced shadow for depth
      marginBottom: '20px', // Space below the component
      transition: 'transform 0.3s, box-shadow 0.3s', // Smooth transition for hover effect
      position: 'relative', // Position relative for absolute positioning of the button
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = 'scale(1.02)'; // Slightly scale up on hover
      e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.2)'; // Deeper shadow on hover
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = 'scale(1)'; // Reset scale on leave
      e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)'; // Reset shadow on leave
    }}
    >
      {/* Copy Button */}
      <button 
        onClick={copyToClipboard} 
        style={{ 
          position: 'absolute', 
          top: '10px', 
          right: '10px', 
          background: 'none', 
          border: 'none', 
          cursor: 'pointer', 
          fontSize: '1.2em', 
          color: '#333' 
        }}
        title="Copy to clipboard"
      >
        📋 {/* Copy symbol */}
      </button>
      <h2 style={{ marginBottom: '10px', color: '#333' }}>Send an SMS using Python</h2>
      <pre style={{ background: '#f0f0f0', padding: '10px', borderRadius: '5px' }}>
        <code>
          {codeSnippet}
        </code>
      </pre>
    </div>
  );
};

const CurlExample = () => {
  const codeSnippet = `REM Make sure this is formatted as a single line with no line breaks
          curl -X POST "https://smstextr.web.app/api/sendsms"
               --data-urlencode "to=+1 123-456-7890"
               --data-urlencode "message=Hello from SMS Textr API!"
               --data-urlencode "apikey=Your_API_Key"`;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(codeSnippet).then(() => {
      alert('Code copied to clipboard!'); // Optional: Notify the user
    });
  };

  return (
    <div style={{ 
      background: 'linear-gradient(135deg, #f9f9f9, #eaeaea)', // Gradient background for depth
      borderRadius: '8px', // Rounded corners
      padding: '20px', // Padding for spacing
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)', // Enhanced shadow for depth
      marginBottom: '20px', // Space below the component
      transition: 'transform 0.3s, box-shadow 0.3s', // Smooth transition for hover effect
      position: 'relative', // Position relative for absolute positioning of the button
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = 'scale(1.02)'; // Slightly scale up on hover
      e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.2)'; // Deeper shadow on hover
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = 'scale(1)'; // Reset scale on leave
      e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)'; // Reset shadow on leave
    }}
    >
      {/* Copy Button */}
      <button 
        onClick={copyToClipboard} 
        style={{ 
          position: 'absolute', 
          top: '10px', 
          right: '10px', 
          background: 'none', 
          border: 'none', 
          cursor: 'pointer', 
          fontSize: '1.2em', 
          color: '#333' 
        }}
        title="Copy to clipboard"
      >
        📋 {/* Copy symbol */}
      </button>
      <h2 style={{ marginBottom: '10px', color: '#333' }}>Send an SMS using Curl</h2>
      <pre style={{ background: '#f0f0f0', padding: '10px', borderRadius: '5px' }}>
        <code>
          {codeSnippet}
        </code>
      </pre>
    </div>
  );
};

const PHPExample = () => {
  const codeSnippet = `$data = http_build_query([
    'to' => '+1 123-456-7890',
    'message' => 'Hello from SMS Textr API!',
    'apikey' => 'Your_API_Key'
]);

$response = file_get_contents(  'https://smstextr.web.app/api/sendsms', 
                                false,
                                stream_context_create([
                                'http' => ['method' => 'POST', 'header' => 
                                'Content-type: application/x-www-form-urlencoded',
                                'content' => $data]
                                ]));

echo $response ?: "Error: Unable to send SMS";`;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(codeSnippet).then(() => {
      alert('Code copied to clipboard!'); // Optional: Notify the user
    });
  };

  return (
    <div style={{ 
      background: 'linear-gradient(135deg, #f9f9f9, #eaeaea)', 
      borderRadius: '8px', 
      padding: '20px', 
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)', 
      marginBottom: '20px', 
      transition: 'transform 0.3s, box-shadow 0.3s', 
      position: 'relative', 
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = 'scale(1.02)'; 
      e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.2)'; 
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = 'scale(1)'; 
      e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)'; 
    }}
    >
      {/* Copy Button */}
      <button 
        onClick={copyToClipboard} 
        style={{ 
          position: 'absolute', 
          top: '10px', 
          right: '10px', 
          background: 'none', 
          border: 'none', 
          cursor: 'pointer', 
          fontSize: '1.2em', 
          color: '#333' 
        }}
        title="Copy to clipboard"
      >
        📋 {/* Copy symbol */}
      </button>
      <h2 style={{ marginBottom: '10px', color: '#333' }}>Send an SMS using PHP</h2>
      <pre style={{ background: '#f0f0f0', padding: '10px', borderRadius: '5px' }}>
        <code>
          {codeSnippet}
        </code>
      </pre>
    </div>
  );
};

const NodeExample = () => {
  const codeSnippet = `const axios = require('axios');

axios.post('https://smstextr.web.app/api/sendsms', {
            to: '+1 123-456-7890',
            message: 'Hello from SMS Textr API!',
            apikey: 'Your_API_Key'
})
.then(response => console.log(response.data))
.catch(error => console.error('Error:', error.response.data));`;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(codeSnippet).then(() => {
      alert('Code copied to clipboard!'); // Optional: Notify the user
    });
  };

  return (
    <div style={{ 
      background: 'linear-gradient(135deg, #f9f9f9, #eaeaea)', 
      borderRadius: '8px', 
      padding: '20px', 
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)', 
      marginBottom: '20px', 
      transition: 'transform 0.3s, box-shadow 0.3s', 
      position: 'relative', 
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = 'scale(1.02)'; 
      e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.2)'; 
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = 'scale(1)'; 
      e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)'; 
    }}
    >
      {/* Copy Button */}
      <button 
        onClick={copyToClipboard} 
        style={{ 
          position: 'absolute', 
          top: '10px', 
          right: '10px', 
          background: 'none', 
          border: 'none', 
          cursor: 'pointer', 
          fontSize: '1.2em', 
          color: '#333' 
        }}
        title="Copy to clipboard"
      >
        📋 {/* Copy symbol */}
      </button>
      <h2 style={{ marginBottom: '10px', color: '#333' }}>Send an SMS using NodeJS</h2>
      <pre style={{ background: '#f0f0f0', padding: '10px', borderRadius: '5px' }}>
        <code>
          {codeSnippet}
        </code>
      </pre>
    </div>
  );
};

const RubyExample = () => {
  const codeSnippet = `        require 'net/http'
        require 'uri'

        uri = URI.parse("https://smstextr.web.app/api/sendsms")
        response = Net::HTTP.post_form(uri, {
                      "to" => "+1 123-456-7890",
                      "message" => "Hello from SMS Textr API!",
                      "apikey" => "Your_API_Key"
                    })
        puts response.body`;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(codeSnippet).then(() => {
      alert('Code copied to clipboard!'); // Optional: Notify the user
    });
  };

  return (
    <div style={{ 
      background: 'linear-gradient(135deg, #f9f9f9, #eaeaea)', 
      borderRadius: '8px', 
      padding: '20px', 
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)', 
      marginBottom: '20px', 
      transition: 'transform 0.3s, box-shadow 0.3s', 
      position: 'relative', 
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = 'scale(1.02)'; 
      e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.2)'; 
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = 'scale(1)'; 
      e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)'; 
    }}
    >
      {/* Copy Button */}
      <button 
        onClick={copyToClipboard} 
        style={{ 
          position: 'absolute', 
          top: '10px', 
          right: '10px', 
          background: 'none', 
          border: 'none', 
          cursor: 'pointer', 
          fontSize: '1.2em', 
          color: '#333' 
        }}
        title="Copy to clipboard"
      >
        📋 {/* Copy symbol */}
      </button>
      <h2 style={{ marginBottom: '10px', color: '#333' }}>Send an SMS using Ruby</h2>
      <pre style={{ background: '#f0f0f0', padding: '10px', borderRadius: '5px' }}>
        <code>
          {codeSnippet}
        </code>
      </pre>
    </div>
  );
};

const JSExample = () => {
  const codeSnippet = `fetch('https://smstextr.web.app/api/sendsms', {
  method: 'POST',
  headers: {'Content-Type': 'application/json'},
  body: JSON.stringify({
    to: '+1 123-456-7890',
    message: 'Hello from SMS Textr API!',
    apikey: 'Your_API_Key'
  }),
})
.then(response => response.json()) 
.then(data => console.log(data));`;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(codeSnippet).then(() => {
      alert('Code copied to clipboard!'); // Optional: Notify the user
    });
  };

  return (
    <div style={{ 
      background: 'linear-gradient(135deg, #f9f9f9, #eaeaea)', 
      borderRadius: '8px', 
      padding: '20px', 
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)', 
      marginBottom: '20px', 
      transition: 'transform 0.3s, box-shadow 0.3s', 
      position: 'relative', 
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = 'scale(1.02)'; 
      e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.2)'; 
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = 'scale(1)'; 
      e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)'; 
    }}
    >
      {/* Copy Button */}
      <button 
        onClick={copyToClipboard} 
        style={{ 
          position: 'absolute', 
          top: '10px', 
          right: '10px', 
          background: 'none', 
          border: 'none', 
          cursor: 'pointer', 
          fontSize: '1.2em', 
          color: '#333' 
        }}
        title="Copy to clipboard"
      >
        📋 {/* Copy symbol */}
      </button>
      <h2 style={{ marginBottom: '10px', color: '#333' }}>Send an SMS using Javascript</h2>
      <pre style={{ background: '#f0f0f0', padding: '10px', borderRadius: '5px' }}>
        <code>
          {codeSnippet}
        </code>
      </pre>
    </div>
  );
};

const JavaExample = () => {
  const codeSnippet = `import java.io.*;
import java.net.HttpURLConnection;
import java.net.URL;

public class Main {
    public static void main(String[] args) {
        String url = "https://smstextr.web.app/api/sendsms";
        String params = "to=+1 123-456-7890"+
                        "&message=Hello from SMS textr API!"+
                        "&apikey=Your_API_Key";
        try {
            HttpURLConnection con = (HttpURLConnection) new URL(url).openConnection();
            con.setRequestMethod("POST");
            con.setDoOutput(true);
            con.setRequestProperty("Content-Type", "application/x-www-form-urlencoded");
            try (OutputStream os = con.getOutputStream()) {
                os.write(params.getBytes("utf-8"));
            }
            int responseCode = con.getResponseCode();
            
            InputStreamReader reader = new InputStreamReader(
                responseCode >= 400 ? con.getErrorStream() : con.getInputStream());
            BufferedReader in = new BufferedReader(reader);
                String line;
                StringBuilder response = new StringBuilder();
                while ((line = in.readLine()) != null) {
                    response.append(line);
                }
                System.out.println("Response JSON: " + response.toString());
            }catch (Exception e) {
            e.printStackTrace();
        }
    }
}`;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(codeSnippet).then(() => {
      alert('Code copied to clipboard!'); // Optional: Notify the user
    });
  };

  return (
    <div style={{ 
      background: 'linear-gradient(135deg, #f9f9f9, #eaeaea)', 
      borderRadius: '8px', 
      padding: '20px', 
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)', 
      marginBottom: '20px', 
      transition: 'transform 0.3s, box-shadow 0.3s', 
      position: 'relative', 
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = 'scale(1.02)'; 
      e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.2)'; 
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = 'scale(1)'; 
      e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)'; 
    }}
    >
      {/* Copy Button */}
      <button 
        onClick={copyToClipboard} 
        style={{ 
          position: 'absolute', 
          top: '10px', 
          right: '10px', 
          background: 'none', 
          border: 'none', 
          cursor: 'pointer', 
          fontSize: '1.2em', 
          color: '#333' 
        }}
        title="Copy to clipboard"
      >
        📋 {/* Copy symbol */}
      </button>
      <h2 style={{ marginBottom: '10px', color: '#333' }}>Send an SMS using Java</h2>
      <pre style={{ background: '#f0f0f0', padding: '10px', borderRadius: '5px' }}>
        <code>
          {codeSnippet}
        </code>
      </pre>
    </div>
  );
};

const CSharpExample = () => {
  const codeSnippet = `using System;
using System.Net.Http;
using System.Text;
using Newtonsoft.Json;

class Program
{
    static async System.Threading.Tasks.Task Main()
    {
        var client = new HttpClient();
        var payload = new { to = "+1 123-456-7890", 
                            message = "Hello from SMS Textr API!", 
                            apikey = "Your_API_Key" };
        var response = await client.PostAsync(
            "https://smstextr.web.app/api/sendsms",
            new StringContent(JsonConvert.SerializeObject(payload), Encoding.UTF8, "application/json")
        );
        Console.WriteLine(await response.Content.ReadAsStringAsync());
    }
}`;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(codeSnippet).then(() => {
      alert('Code copied to clipboard!'); // Optional: Notify the user
    });
  };

  return (
    <div style={{ 
      background: 'linear-gradient(135deg, #f9f9f9, #eaeaea)', 
      borderRadius: '8px', 
      padding: '20px', 
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)', 
      marginBottom: '20px', 
      transition: 'transform 0.3s, box-shadow 0.3s', 
      position: 'relative', 
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = 'scale(1.02)'; 
      e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.2)'; 
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = 'scale(1)'; 
      e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)'; 
    }}
    >
      {/* Copy Button */}
      <button 
        onClick={copyToClipboard} 
        style={{ 
          position: 'absolute', 
          top: '10px', 
          right: '10px', 
          background: 'none', 
          border: 'none', 
          cursor: 'pointer', 
          fontSize: '1.2em', 
          color: '#333' 
        }}
        title="Copy to clipboard"
      >
        📋 {/* Copy symbol */}
      </button>
      <h2 style={{ marginBottom: '10px', color: '#333' }}>Send an SMS using C#</h2>
      <pre style={{ background: '#f0f0f0', padding: '10px', borderRadius: '5px' }}>
        <code>
          {codeSnippet}
        </code>
      </pre>
    </div>
  );
};

const ResponseReceived = () => (
  <div style={{ 
    background: 'linear-gradient(135deg, #f9f9f9, #eaeaea)', // Gradient background for depth
    borderRadius: '8px', // Rounded corners
    padding: '20px', // Padding for spacing
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)', // Enhanced shadow for depth
    marginBottom: '20px', // Space below the component
    transition: 'transform 0.3s, box-shadow 0.3s', // Smooth transition for hover effect
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.transform = 'scale(1.02)'; // Slightly scale up on hover
    e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.2)'; // Deeper shadow on hover
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.transform = 'scale(1)'; // Reset scale on leave
    e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)'; // Reset shadow on leave
  }}
  >
    <h2 style={{ marginBottom: '10px', color: '#333' }}>The Response Received</h2>
    <p>After sending an SMS, the API will return a JSON response as follows.</p>
    <pre style={{ background: '#f0f0f0', padding: '10px', borderRadius: '5px' }}>
      <code>
          <b><strong>If the SMS went through successfully:</strong></b><br /><br />
      {'{'}<br />
           &nbsp; "success": "true",<br />
           &nbsp; "message_id": "The ID of sent Message."<br />
      {'}'}<br /><br /><br />
          <b><strong>If the SMS failed because of a missing field:</strong></b><br /><br />
      {'{'}<br />
           &nbsp; "success": "false",<br />
           &nbsp; "error": "Missing required fields: "to", "message" or "apikey""<br />
      {'}'}<br /><br /><br />
      <b><strong>If the SMS failed because of an incorrect API Key:</strong></b><br /><br />
      {'{'}<br />
           &nbsp; "success": "false",<br />
           &nbsp; "error": "User not found for the provided API key"<br />
      {'}'}<br /><br /><br /> 
      <b><strong>If the SMS failed because of insufficient credits:</strong></b><br /><br />
      {'{'}<br />
           &nbsp; "success": "false",<br />
           &nbsp; "error": "Credit Balance is 0. Please purchase credits from the Dashboard to send SMS."<br />
      {'}'}<br /><br /><br /> 
      <b><strong>If the SMS failed for any other reason:</strong></b><br /><br />
      {'{'}<br />
           &nbsp; "success": "false",<br />
           &nbsp; "error": "Failed to send SMS"<br />
      {'}'}<br /><br /><br /> 
      </code>
    </pre>
  </div>
);

const TestingAPI = () => (
  <div style={{ 
    background: 'linear-gradient(135deg, #f9f9f9, #eaeaea)', // Gradient background for depth
    borderRadius: '8px', // Rounded corners
    padding: '20px', // Padding for spacing
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)', // Enhanced shadow for depth
    marginBottom: '20px', // Space below the component
    transition: 'transform 0.3s, box-shadow 0.3s', // Smooth transition for hover effect
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.transform = 'scale(1.02)'; // Slightly scale up on hover
    e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.2)'; // Deeper shadow on hover
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.transform = 'scale(1)'; // Reset scale on leave
    e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)'; // Reset shadow on leave
  }}
  >
    <h2 style={{ marginBottom: '10px', color: '#333' }}>Testing the API</h2>
    <pre style={{ background: '#f0f0f0', padding: '10px', borderRadius: '5px', whiteSpace: 'pre-wrap' }}>
      <code>       
            To validate your API key without consuming credits, 
            simply append "_test" to your key when making a request to the  
            <span style={{ color: 'green' }}> https://smstextr.web.app/api/sendsms</span> endpoint.
            <br />This allows you to check that a message would be successfully sent, 
            but it will not count against your text credits.<br /><br />
        {'{'}<br />
          "to":       "+1 123-456-7890",<br />
          "message":  "Hello from SMS Textr API!"<br />
          "apikey":   "<i>Your_API_Key_test</i>"<br />
        {'}'}
      </code>
    </pre>
  </div>
);

const ReceivingSMSReplies = () => (
  <div style={{ 
    background: 'linear-gradient(135deg, #f9f9f9, #eaeaea)', // Gradient background for depth
    borderRadius: '8px', // Rounded corners
    padding: '20px', // Padding for spacing
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)', // Enhanced shadow for depth
    marginBottom: '20px', // Space below the component
    transition: 'transform 0.3s, box-shadow 0.3s', // Smooth transition for hover effect
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.transform = 'scale(1.02)'; // Slightly scale up on hover
    e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.2)'; // Deeper shadow on hover
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.transform = 'scale(1)'; // Reset scale on leave
    e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)'; // Reset shadow on leave
  }}
  >
    <h2 style={{ marginBottom: '10px', color: '#333' }}>Receiving SMS replies/responses</h2>
    <pre style={{ background: '#f0f0f0', padding: '10px', borderRadius: '5px', whiteSpace: 'pre-wrap' }}>
      <code>       
            SMS Textr lets you receive replies to SMS you've sent. Replies are sent by webhook, 
            meaning you will have to set up an HTTP or HTTPS route on your website that will process inbound SMS.  
            Insert this Webhook Url in the "Webhook URL to Receive SMS" field in the Dashboard. 
            Alternately, if you do not want to receive SMS you can let the field remain 
            to the default value <span style={{ color: 'green' }}>https://default-webhook-url.com</span>.
            <strong><br />**Please note that receiving SMS reply is only possible from number's that you have sent an SMS to.<br /></strong>
            <br />The response received will be a JSON payload as below:<br /><br />
        {'{'}<br />
            "MessageId": "34CharactersLongMessageID",<br />
            "Sender": "+1234567890",<br />
            "Message": "Hi, SMS Textr!",<br />
            "Status": "Received",<br />
            "DateTime": "1/1/2025, 12:00:00 PM"<br />
        {'}'}<br /><br /><br /><br />
            Example to handle JSON payload received:<br /><br />
            const express = require("express");<br />
            const app = express();<br /><br />

            app.use(express.json()); // Middleware to parse JSON <br />
            app.post{'('}"/webhook-receiver", (req, res) ={'>'} {'{'}<br />
            const {'{'} MessageId, Sender, Message, Status, DateTime {'}'} = req.body;<br /><br />

            console.log{'('}"New SMS Received:"{')'};<br />
            console.log{'('}`From: ${'{'}Sender{'}'}`{')'};<br />
            console.log{'('}`Message: ${'{'}Message{'}'}`{')'};<br />
            console.log{'('}`Status: ${'{'}Status{'}'}`{')'};<br />
            console.log{'('}`Received At: ${'{'}DateTime{'}'}`{')'};<br /><br />
            
            // You can save this data to a database or trigger an action<br />
            res.status{'('}200{')'}.send{'('}"Webhook received successfully"{')'};<br />
            {'}'}{')'};<br /><br />

            app.listen{'('}3000, () ={'>'} console.log{'('}"🚀 Webhook listening on port 3000"{')'}{')'};

      </code>
    </pre>
  </div>
);

const SupportedRegions = () => (
  <div style={{ 
    background: 'linear-gradient(135deg, #f9f9f9, #eaeaea)', // Gradient background for depth
    borderRadius: '8px', // Rounded corners
    padding: '20px', // Padding for spacing
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)', // Enhanced shadow for depth
    marginBottom: '20px', // Space below the component
    transition: 'transform 0.3s, box-shadow 0.3s', // Smooth transition for hover effect
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.transform = 'scale(1.02)'; // Slightly scale up on hover
    e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.2)'; // Deeper shadow on hover
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.transform = 'scale(1)'; // Reset scale on leave
    e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)'; // Reset shadow on leave
  }}
  >
    <h2 style={{ marginBottom: '10px', color: '#333' }}>Supported Regions</h2>
    <pre style={{ background: '#f0f0f0', padding: '10px', borderRadius: '5px', whiteSpace: 'pre-wrap' }}>
      <code>       
            To view the list of supported regionsand their associated credits, check out our <a href="/regions" style={{ color: '#007BFF' }}>Regions page</a>.
      </code>
    </pre>
  </div>
);

export default DocsPage;
